import { Vector3 } from 'three';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import range from 'lodash/range';
import {
  COPPER_FILL,
  COPPER_SEGNEMTS,
  COPPER_THICKNESS,
  NOOP,
  PCB_SIZE
} from '../../../constants/globals';
import CopperStrip from './CopperStrip';
import Material from '../../../models/Material';

class Copper extends Component {
  constructor(prop) {
    super(prop);
    this.state = {
      hovered: false,
    };
    this._onMouseEnter = this._onMouseEnter.bind(this);
    this._onMouseLeave = this._onMouseLeave.bind(this);
    this._onClick = this._onClick.bind(this);
    this._ref = this._ref.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { freezeMouseEvents: currFreeze } = this.props;
    const prevFreeze = prevProps.freezeMouseEvents;

    // remove highglight when unfreeze the mouse events
    if (prevFreeze === true && currFreeze === false) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        hovered: false
      });
    }
  }

  _onMouseEnter() {
    const { setHoveredLayer, target } = this.props;
    this.setState({
      hovered: true,
    }, () => {
      setHoveredLayer && setHoveredLayer(target)
    });
  }

  _onMouseLeave() {
    const { unSetHoveredLayer, target } = this.props;
    this.setState({
      hovered: false,
    }, () => {
      unSetHoveredLayer && unSetHoveredLayer(target);
    });
  }

  _onClick() {
    const { onLayerClicked, target } = this.props;
    onLayerClicked(target);
  }

  _ref(material) {
    const { onCreate } = this.props;
    onCreate && onCreate(material);
  }

  render() {
    const { freezeMouseEvents, thickness, position, copperFill, hasWarning } = this.props;
    const { hovered } = this.state;

    const adjustedCopperFill = copperFill >= 1 ? 1 : copperFill;
    const width = PCB_SIZE.width;
    const height = thickness;
    const segments = (copperFill >= 1) ? 1 : COPPER_SEGNEMTS;
    const segmentWidth = PCB_SIZE.width / segments;
    const stripWidth  = segmentWidth * adjustedCopperFill;
    const beginningX = -(width / 2) + (stripWidth / 2);
    const hoverHighlight = hovered;

    const onMouseEnter = freezeMouseEvents ? NOOP : this._onMouseEnter;
    const onMouseLeave = freezeMouseEvents ? NOOP : this._onMouseLeave;
    const onClick = freezeMouseEvents ? NOOP : this._onClick;

    return (
      <group
        position={position}
        ref={this._ref}
      >
        {
          range(segments).map((index)=>{
            const x = beginningX + index * ((width - stripWidth) / (segments - 1));
            const position = new Vector3(x, 0, 0);

            return (
              <CopperStrip
                key={index}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                onClick={onClick}
                position={position}
                width={stripWidth}
                height={height}
                hoverHighlight={hoverHighlight}
                warningHighlight={hasWarning}
              />
            );
          })
        }
      </group>
    );
  }
}

Copper.displayName = 'Copper';

Copper.propTypes = {
  copperFill: PropTypes.number,
  target: PropTypes.instanceOf(Material).isRequired,
  position:   PropTypes.instanceOf(Vector3),
  thickness:  PropTypes.number,
  onLayerClicked: PropTypes.func,
  freezeMouseEvents: PropTypes.bool,
  onCreate: PropTypes.func,
  setHoveredLayer: PropTypes.func,
  unSetHoveredLayer: PropTypes.func,
  hasWarning: PropTypes.bool,
}

Copper.defaultProps = {
  copperFill: COPPER_FILL,
  position: new Vector3(),
  thickness: COPPER_THICKNESS,
  onLayerClicked: () => {},
  freezeMouseEvents: false,
  onCreate: null,
  setHoveredLayer: null,
  unSetHoveredLayer: null,
  hasWarning: false,
}

export default Copper;



// WEBPACK FOOTER //
// ./src/components/common/materials/Copper.js